var render = function render(){
  var _vm$order$customer, _vm$order$customer$ac, _vm$order$customer2, _vm$order$calculatedP, _vm$order$calculatedP2, _vm$invoices$, _vm$order$calculatedP3, _vm$order$calculatedP4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return Object.keys(_vm.order).length ? _c('div', [_c('bookingInfoCard', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "order-updated": _vm.handleOrderUpdated
    }
  }, [_c('ValidationSystems', {
    attrs: {
      "order-id": _vm.order.id,
      "validity": _vm.order.validity,
      "showTextCaption": true
    }
  }), _c('v-divider', {
    staticClass: "ml-3 mr-3 mb-5 mt-5",
    attrs: {
      "inset": "",
      "vertical": ""
    }
  })], 1), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8"
    }
  }, [_vm.invoices && _vm.invoices.length > 0 ? _c('div', {
    staticClass: "invoices-container mb-6",
    style: _vm.invoices.length > 2 ? 'max-height: 400px; overflow-y: auto;' : ''
  }, _vm._l(_vm.invoices, function (invoice, index) {
    return invoice ? _c('invoiceInfo', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "invoice": invoice
      }
    }) : _vm._e();
  }), 1) : _vm._e(), _c('Passengers', {
    attrs: {
      "passengers": _vm.order.passengers,
      "canBeEdited": _vm.order.containsToraBooking && _vm.order.isPaid && !_vm.order.anonymized,
      "orderId": _vm.orderId
    },
    on: {
      "passenger-updated": function ($event) {
        return _vm.initial();
      }
    }
  }), _c('div', {
    staticClass: "white elevation-1 rounded pa-5 pt-2 mt-2"
  }, [_c('v-row', [_c('v-col', [_c('h4', {
    staticClass: "mb-1 mt-3"
  }, [_vm._v("Message to customer")]), _c('div', {
    staticClass: "editor-compact"
  }, [_c('vue-editor', {
    attrs: {
      "editor-toolbar": _vm.customToolbar
    },
    model: {
      value: _vm.order.externalMessage,
      callback: function ($$v) {
        _vm.$set(_vm.order, "externalMessage", $$v);
      },
      expression: "order.externalMessage"
    }
  })], 1)]), _c('v-col', [_c('h4', {
    staticClass: "mb-1 mt-3"
  }, [_vm._v("Internal message")]), _c('div', {
    staticClass: "editor-compact",
    attrs: {
      "id": "internalMessage"
    }
  }, [_c('vue-editor', {
    staticStyle: {
      "background-color": "#fff6d9"
    },
    attrs: {
      "editor-toolbar": _vm.customToolbar
    },
    model: {
      value: _vm.order.internalMessage,
      callback: function ($$v) {
        _vm.$set(_vm.order, "internalMessage", $$v);
      },
      expression: "order.internalMessage"
    }
  })], 1)])], 1), _c('v-row', [_c('v-col', {
    staticClass: "text-right pt-0"
  }, [_c('v-btn', {
    attrs: {
      "color": "accent"
    },
    on: {
      "click": function ($event) {
        return _vm.updateMessage();
      }
    }
  }, [_vm._v(" UPDATE ")])], 1)], 1)], 1), _vm.order.containsToraBooking && !_vm.order.isExpired ? _c('TraidComments', {
    staticClass: "mt-2",
    attrs: {
      "order-id": _vm.orderId,
      "bookings": _vm.order.bookings
    },
    on: {
      "comment-changed": _vm.initial
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4"
    }
  }, [_vm.order.company ? _c('v-card', {
    staticClass: "py-3 px-6 mb-4"
  }, [_c('div', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red--text"
  }, [_vm._v("Ordering Company")]), _c('div', {
    staticClass: "ordering-company-content mt-2"
  }, [_c('div', {
    staticClass: "ordering-company-left"
  }, [_c('div', {
    staticClass: "ordering-company-icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "20"
    }
  }, [_vm._v("mdi-domain")])], 1), _c('div', [_c('div', {
    staticClass: "text-body-2 font-weight-medium"
  }, [_vm._v(_vm._s(_vm.order.company.name))]), _vm.order.company.organizationNumber ? _c('div', {
    staticClass: "text-caption grey--text text--darken-2"
  }, [_vm._v(" Org. no " + _vm._s(_vm.order.company.organizationNumber) + " ")]) : _vm._e()])]), _c('v-btn', {
    staticClass: "text-none ml-auto",
    attrs: {
      "text": "",
      "small": "",
      "color": "accent"
    },
    on: {
      "click": function ($event) {
        return _vm.openCompanyDetail();
      }
    }
  }, [_c('span', {
    staticClass: "text-decoration-underline"
  }, [_vm._v("See details")]), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)]) : _vm._e(), _vm.account ? _c('v-card', {
    staticClass: "py-3 px-6 mb-4"
  }, [_c('h3', {
    staticClass: "text-subtitle-1 font-weight-bold mango-red--text"
  }, [_vm._v(" Account Details "), _vm.mailMessage ? _c('span', {
    staticClass: "accent--text mail-message",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("( E-mail matching account found )")]) : _vm._e()]), _c('div', {
    staticClass: "account-details-grid mt-2 text-body-2"
  }, [_c('h4', {
    staticClass: "d-flex justify-space-between accent--text"
  }, [_vm._v("Name"), _c('span', [_vm._v(":")])]), _c('span', {
    staticClass: "account-details-value"
  }, [_vm._v(_vm._s(_vm.account.firstName) + " " + _vm._s(_vm.account.lastName))]), _c('h4', {
    staticClass: "d-flex justify-space-between accent--text"
  }, [_vm._v("Email"), _c('span', [_vm._v(":")])]), _c('span', {
    staticClass: "account-details-value"
  }, [_vm._v(_vm._s(_vm.account.email))]), _vm.account.phone ? [_c('h4', {
    staticClass: "d-flex justify-space-between accent--text"
  }, [_vm._v("Phone"), _c('span', [_vm._v(":")])]), _c('span', {
    staticClass: "account-details-value"
  }, [_vm._v(_vm._s(_vm.account.phone))])] : _vm._e()], 2)]) : _vm._e(), _c('Customer', {
    attrs: {
      "order-id": _vm.order.id,
      "customer": _vm.order.customer
    },
    on: {
      "updated": function ($event) {
        return _vm.initial();
      }
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('Items', {
    attrs: {
      "initial": _vm.initial,
      "token": _vm.token,
      "orderStatus": _vm.order.status,
      "orderId": _vm.order.id,
      "orderToken": _vm.order.token,
      "orderAccountId": (_vm$order$customer = _vm.order.customer) === null || _vm$order$customer === void 0 ? void 0 : (_vm$order$customer$ac = _vm$order$customer.accountInfo) === null || _vm$order$customer$ac === void 0 ? void 0 : _vm$order$customer$ac.id,
      "customerEmail": (_vm$order$customer2 = _vm.order.customer) === null || _vm$order$customer2 === void 0 ? void 0 : _vm$order$customer2.email,
      "items": _vm.order.items,
      "printableItemIds": _vm.order.printableItemIds,
      "printedItemIds": _vm.order.printedItemIds,
      "order-is-paid": _vm.order.isPaid,
      "contains-tora-booking": _vm.order.containsToraBooking,
      "bookings": _vm.order.bookings,
      "base-currency": _vm.order.calculatedPrice.base.currency,
      "tenant-id": _vm.order.seller.tenant.id,
      "tenant-name": _vm.order.seller.tenant.name,
      "canSellTaxis": _vm.order.seller.tenant.canSellTaxis,
      "can-use-giftcard": _vm.order.seller.tenant.canUseGiftCards,
      "order-fully-paid": _vm.order.isFullyPaid,
      "order-total-price": (_vm$order$calculatedP = _vm.order.calculatedPrice) === null || _vm$order$calculatedP === void 0 ? void 0 : (_vm$order$calculatedP2 = _vm$order$calculatedP.total) === null || _vm$order$calculatedP2 === void 0 ? void 0 : _vm$order$calculatedP2.amount,
      "locale": _vm.order.locale,
      "is-international": _vm.order.isInternational
    },
    on: {
      "updateOrder": _vm.initial
    }
  })], 1)], 1), _c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('header', {
    staticClass: "theme--light v-navigation-drawer elevation-1",
    staticStyle: {
      "height": "50px",
      "border-radius": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__content",
    staticStyle: {
      "height": "50px",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__title"
  }, [_c('h4', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "mango-red"
  }, [_vm._v("Activity log ")]), _vm._v("(" + _vm._s(_vm.order.events.length) + ")")])])])]), _c('v-card', [_c('v-card-text', {
    staticClass: "elevation-1"
  }, [_c('v-timeline', {
    attrs: {
      "dense": "",
      "align-top": ""
    }
  }, [_c('v-timeline-item', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "icon": "mdi-account",
      "fill-dot": "",
      "large": ""
    }
  }, [_c('ValidationObserver', {
    ref: "eventObserver"
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "status",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('v-text-field', {
          attrs: {
            "error-messages": errors,
            "label": "Leave a comment...",
            "hide-details": "",
            "solo": ""
          },
          scopedSlots: _vm._u([{
            key: "append",
            fn: function () {
              return [_c('v-btn', {
                staticClass: "mx-0 accent",
                attrs: {
                  "loading": _vm.event.loading,
                  "depressed": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.createEvent();
                  }
                }
              }, [_vm._v("Post ")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.event.comment,
            callback: function ($$v) {
              _vm.$set(_vm.event, "comment", $$v);
            },
            expression: "event.comment"
          }
        })];
      }
    }], null, false, 834621368)
  })], 1)], 1), _c('event-list', {
    attrs: {
      "events": _vm.order.events
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    staticClass: "pa-5",
    attrs: {
      "loading": _vm.isLoading,
      "width": "500px"
    },
    on: {
      "click:outside": function ($event) {
        _vm.orderFilesDialog = false;
      }
    },
    model: {
      value: _vm.orderFilesDialog,
      callback: function ($$v) {
        _vm.orderFilesDialog = $$v;
      },
      expression: "orderFilesDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "title",
    attrs: {
      "fixed": "",
      "color": "titlebg",
      "dense": "",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-2"
  }, [_vm._v("Order Files")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.orderFilesDialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('orderFiles', {
    key: Math.random(),
    attrs: {
      "files": _vm.orderFilesData
    }
  })], 1)], 1), _c('v-dialog', {
    staticClass: "pa-5",
    attrs: {
      "width": "1000px"
    },
    on: {
      "click:outside": function ($event) {
        _vm.companyDetailDialog = false;
      }
    },
    model: {
      value: _vm.companyDetailDialog,
      callback: function ($$v) {
        _vm.companyDetailDialog = $$v;
      },
      expression: "companyDetailDialog"
    }
  }, [_vm.companyDetail ? _c('v-card', [_c('v-toolbar', {
    staticClass: "title",
    attrs: {
      "fixed": "",
      "color": "titlebg",
      "dense": "",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-2"
  }, [_vm._v("Company : " + _vm._s(_vm.companyDetail.name))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.companyDetailDialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('CompanyDetail', {
    attrs: {
      "company": _vm.companyDetail,
      "loading": _vm.companyCustomersLoading
    }
  })], 1) : _vm._e()], 1), _c('float-buttons', {
    attrs: {
      "isCompany": _vm.order.invoiceId,
      "customer": _vm.order.customer,
      "invoice-customer": (_vm$invoices$ = _vm.invoices[0]) === null || _vm$invoices$ === void 0 ? void 0 : _vm$invoices$.customer,
      "order-locale": _vm.order.locale,
      "order-id": _vm.orderId,
      "order-is-paid": _vm.order['isPaid'],
      "order-is-fully-paid": _vm.order['isFullyPaid'],
      "order-is-anonymized": _vm.order.anonymized,
      "order-is-payment-possible": _vm.order['isPaymentPossible'],
      "is-archived-order": _vm.order.archived,
      "order-total-price": (_vm$order$calculatedP3 = _vm.order.calculatedPrice) === null || _vm$order$calculatedP3 === void 0 ? void 0 : (_vm$order$calculatedP4 = _vm$order$calculatedP3.total) === null || _vm$order$calculatedP4 === void 0 ? void 0 : _vm$order$calculatedP4.amount,
      "order-contains-rail-passes": _vm.includesRailPass(_vm.order.items),
      "order-is-lock-required": _vm.order.isLockRequired,
      "order-has-items": _vm.order.items.length > 0
    },
    on: {
      "get-files": function ($event) {
        return _vm.getOrderFiles($event);
      },
      "initials": _vm.initial
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }